module.exports = __webpack_public_path__ + "img/download.564a05b3.png";